import React from 'react'

const ControlButton = ({ className, action, title, icon }) => (
  <button
    className={className}
    onClick={action}
    title={title}
    aria-label={title}
  >
    {icon}
  </button>
)

export default ControlButton
